import { configureStore } from "@reduxjs/toolkit";
import { reducer } from "./reducer";
import { authApi } from "../features/auth/api/authApi";
import { chatApi } from "../features/chat/api/chatApi";
import { unauthorizedMiddleware } from "../utils/auth";
import { employeeApi } from "../features/employee/api/employeeApi";
import { ApiCredentials } from "../features/apiCredentials/api/ApiCredentials";
import { companyApi } from "../features/company/api/companyApi";
import { businessHrsApi } from "../features/businessHour/api/businessHourApi";
import { scheduleMessageApi } from "../features/scheduleMessages/api/scheduleMessageApi";
import { bulkUploadApi } from "../features/bulkUpload/api/bulkUploadApi";

const store = configureStore({
    reducer: reducer,
    middleware: (getDefaultMiddleware) =>
        getDefaultMiddleware({
            serializableCheck: false,
        }).concat(
            unauthorizedMiddleware,
            authApi.middleware,
            chatApi.middleware,
            employeeApi.middleware,
            ApiCredentials.middleware,
            companyApi.middleware,
            businessHrsApi.middleware,
            scheduleMessageApi.middleware,
            bulkUploadApi.middleware
        )
})

export default store;